/**
* Instafeed JS
* -----------------------------------------------------------------------------
*
* All the JS for the Instafeed component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'instafeed',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.instafeed .images-area' ).magnificPopup( {
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: true,
        },
      } );

      $( '.instafeed .image-wrapper' ).mouseenter( function() {
        $( this ).closest( '.instafeed' ).find( '.image-wrapper' ).not( this ).addClass( 'is-blurred' );
      } ).mouseleave( function() {
        $( this ).closest( '.instafeed' ).find( '.image-wrapper' ).not( this ).removeClass( 'is-blurred' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'instafeed', COMPONENT );
} )( app );
